import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { PackageIcon, DownloadIcon, StarIcon } from 'lucide-react';
export function BundleHighlight() {
  return <section id="bundle" className="py-16 sm:py-24 lg:py-32 bg-[#0a0a0a] relative overflow-hidden" data-id="element-18">
      {/* Deep red glow behind the bundle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#8b1a1a]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-19" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative" data-id="element-21">
          {/* Stacked Folders Effect (Background layers) */}
          <div className="absolute -top-4 -left-4 right-4 bottom-4 bg-[#6b1515] border border-[#8b1a1a] rounded shadow-2xl rotate-[-2deg] opacity-50" data-id="element-22" />
          <div className="absolute -top-2 -left-2 right-2 bottom-2 bg-[#7a1717] border border-[#8b1a1a] rounded shadow-2xl rotate-[1deg] opacity-80" data-id="element-23" />

          {/* Main Card */}
          <div className="relative bg-[#8b1a1a] border border-[#a01f1f] rounded shadow-[0_30px_60px_rgba(0,0,0,0.8)] p-6 sm:p-16 overflow-hidden" data-id="element-24">
            {/* Texture overlay */}
            <div className="absolute inset-0 bg-noise opacity-30 mix-blend-overlay" data-id="element-25" />
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1626265774643-f1943311a86b?q=80&w=1000&auto=format&fit=crop')] opacity-10 mix-blend-luminosity bg-cover bg-center" data-id="element-26" />

            <div className="relative z-10 text-center space-y-5 sm:space-y-8" data-id="element-27">
              <div className="inline-flex items-center space-x-2 text-[#ece3d0] mb-1 sm:mb-2 bg-black/20 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-white/10 backdrop-blur-sm" data-id="element-28">
                <PackageIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-29" />
                <span className="font-typewriter text-xs sm:text-sm uppercase tracking-widest" data-id="element-30">
                  Featured Bundle
                </span>
              </div>

              <h2 className="font-typewriter text-2xl sm:text-5xl lg:text-6xl text-[#ece3d0] drop-shadow-lg" data-id="element-31">
                Can't choose? You don't have to.
              </h2>

              <div className="bg-[#ece3d0] bg-paper-texture rounded p-6 sm:p-12 text-[#1a1a1a] shadow-2xl max-w-3xl mx-auto border border-[#d4c5b0] relative" data-id="element-32">
                {/* Wax Seal / Stamp */}
                <div className="absolute -top-5 -right-3 sm:-top-6 sm:-right-6 w-20 h-20 sm:w-24 sm:h-24 bg-[#8b1a1a] rounded-full flex items-center justify-center text-[#ece3d0] font-typewriter font-bold text-sm sm:text-lg rotate-[15deg] shadow-lg border-2 border-[#6b1515]" data-id="element-33">
                  SAVE
                  <br data-id="element-34" />
                  $98
                </div>

                <h3 className="font-typewriter text-2xl sm:text-4xl mb-2 sm:mb-4 font-bold" data-id="element-35">
                  The Complete Dossier
                </h3>
                <p className="font-serif-body text-base sm:text-xl text-[#2a2a2a] mb-5 sm:mb-8" data-id="element-36">
                  All 4 cases. One collection. One night for every occasion.
                </p>

                <div className="flex items-center justify-center space-x-4 sm:space-x-6 mb-5 sm:mb-8" data-id="element-37">
                  <span className="font-typewriter text-2xl sm:text-4xl font-bold line-through text-[#1a1a1a]/40 decoration-[#8b1a1a] decoration-4" data-id="element-38">
                    $140
                  </span>
                  <span className="font-typewriter text-5xl sm:text-7xl font-bold text-[#8b1a1a] drop-shadow-sm" data-id="element-39">
                    $42
                  </span>
                </div>

                <div className="space-y-2 text-sm text-[#1a1a1a]/70 mb-5 sm:mb-8 font-serif-body sm:text-lg" data-id="element-40">
                  <div className="flex items-center justify-center space-x-2" data-id="element-41">
                    <DownloadIcon className="w-4 h-4 sm:w-5 sm:h-5 text-[#8b1a1a] shrink-0" data-id="element-42" />
                    <span data-id="element-43">
                      Instant download. All four cases delivered immediately.
                    </span>
                  </div>
                </div>

                <button className="w-full bg-[#1a1a1a] hover:bg-[#2a2a2a] text-[#ece3d0] py-4 sm:py-5 rounded font-typewriter font-bold text-sm sm:text-lg tracking-wider transition-all hover:shadow-xl uppercase border border-black" data-id="element-44">
                  GET THE COMPLETE COLLECTION — $42 USD
                </button>
              </div>

              <p className="font-serif-body text-[#ece3d0]/80 text-base sm:text-xl pt-2 sm:pt-4 italic" data-id="element-45">
                Four cases. Four levels of intensity. Months of unforgettable
                nights.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Social Proof — trust panel beneath the bundle */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-8 sm:mt-12 flex justify-center" data-id="element-46">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-7 rounded-xl border border-[#ece3d0]/15 bg-[#121212] px-5 py-3 sm:px-6 sm:py-4 shadow-[0_8px_40px_rgba(0,0,0,0.6)]" data-id="element-47">
            {/* Avatars */}
            <div className="flex -space-x-3" data-id="element-48">
              {['https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200&auto=format&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=200&auto=format&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop&crop=faces'].map((img, i) => <img key={i} src={img} alt={`Detective ${i + 1}`} loading="lazy" className="w-11 h-11 rounded-full border-2 border-[#ece3d0]/80 object-cover grayscale contrast-110 shadow-[0_2px_8px_rgba(0,0,0,0.7)] ring-1 ring-black/40" data-id="element-49" />)}
              <div className="w-11 h-11 rounded-full border-2 border-[#8b1a1a]/70 bg-[#0a0a0a] flex items-center justify-center text-[#ece3d0] font-typewriter text-[11px] tracking-tight shadow-[0_2px_8px_rgba(0,0,0,0.7)]" data-id="element-50">
                +995
              </div>
            </div>

            {/* Divider */}
            <div className="hidden sm:block w-px h-12 bg-[#ece3d0]/15" data-id="element-51" />

            {/* Rating */}
            <div className="flex flex-col items-center sm:items-start" data-id="element-52">
              <div className="flex items-center gap-2" data-id="element-53">
                <div className="flex items-center gap-0.5 text-amber-400 drop-shadow-[0_0_6px_rgba(251,191,36,0.4)]" data-id="element-54">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-4 h-4 fill-current" data-id="element-55" />)}
                </div>
                <span className="font-typewriter text-[#ece3d0] text-base tracking-tight" data-id="element-56">
                  4.9<span className="text-[#ece3d0]/50 text-sm" data-id="element-57">/5</span>
                </span>
              </div>
              <p className="font-typewriter text-[11px] uppercase tracking-[0.18em] text-[#ece3d0]/55 mt-1.5" data-id="element-58">
                1,000+ detectives have opened the files
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}